<script>
import Layout from "@/views/layouts/default";
import appConfig from "@/app.config";
import pdf from 'vue-pdf'

import {
  required,
  email,
  requiredIf,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

export default {
  name: "UpdateProfile",
  page: {
    title: "Ubah Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    pdf
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        address: "",
        industry_id: null,
        province_id: null,
        city_id: null,
        zip_code: "",
        contact_person: "",
        yearly_income: "",
        other_certification: "",
      },
      certifications: [],
      certificationList: [ 'ALFA/IFA', 'IATA', 'FIATA', 'Barang Berbahaya', 'Lainnya'
      ],
      industryList: [],
      provinceList: [],
      cityList: [
        { value: null, text: 'Please select a province first' }
      ],
      documents: {
        deed_of_incorporation_path: null,
        siup_path: null,
        npwp_path: null,
        skdp_path: null,
        nib_path: null,
      },
      document: {
        type: "",
        src: ""
      },
      isUpdateProfileError: false,
      errorMessage: null,
      isUpdateProfileSuccess: false,
      successMessage: null,
    };
  },
  validations: {
    form: {
      name: { required },
      email: { required, email },
      phone: { required, minLength: minLength(8), maxLength: maxLength(15) },
      address: { required },
      industry_id: { required },
      province_id: { required },
      city_id: { required },
      zip_code: { required },
      contact_person: { required },
      yearly_income: { required },
      other_certification: {
        required: requiredIf(function () {
            const other = this.certifications.find(item => item === 5)
            return other !== undefined
          }
        ),
      },
    }
  },
  created() {
    this.getProfile()
    this.getIndustries()
    this.getProvinces()
  },
  methods: {
    submitUpdateProfile() {
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // hit api disini
        const certifications = {
          alfa_ifa: this.certifications.findIndex(item => item === 'ALFA/IFA') >= 0,
          iata: this.certifications.findIndex(item => item === 'IATA') >= 0,
          fiata: this.certifications.findIndex(item => item === 'FIATA') >= 0,
          dangerous_good: this.certifications.findIndex(item => item === 'Barang Berbahaya') >= 0,
          others: this.certifications.findIndex(item => item === 'Lainnya') >= 0,
          other_detail: this.certifications.findIndex(item => item === 'Lainnya') >= 0 ? this.form.other_certification : ""
        }

        const payload = {
          ...this.form,
          yearly_income: this.convertToAngka(this.form.yearly_income).toString(),
          certificates: certifications
        }
        delete payload.other_certification
        window.scrollTo(0,0);

        this.$axios.put('/v1/logistic_company/auth/change_profile', payload)
          .then(response => {
            this.isUpdateProfileSuccess = true
            this.isUpdateProfileError = false
            this.successMessage = response.data.message
          }).catch(error => {
            this.isUpdateProfileSuccess = false
            this.isUpdateProfileError = true
            this.errorMessage = error.response.data.message
          })
      }
    },
    submitLegalDocument() {
      this.$axios.put('/v1/logistic_company/auth/change_legal_document', {
        legal_documents: this.documents
      })
        .catch(error => {
          this.isUpdateProfileSuccess = false
          this.isUpdateProfileError = true
          this.errorMessage = error.response.data.message
        })
    },
    getProfile() {
      this.$axios.get('/v1/logistic_company/auth/profile')
        .then(response => {
          const lc = response.data.data.logistic_company
          this.form = {
            name: lc.name,
            email: lc.email,
            phone: lc.phone,
            address: lc.address,
            industry_id: lc.industry_id.toString(),
            province_id: lc.province_id.toString(),
            city_id: lc.city_id.toString(),
            zip_code: lc.zip_code,
            contact_person: lc.contact_person,
            yearly_income: lc.yearly_income,
            other_certification: lc.certificates ? lc.certificates.other_detail : ""
          }
          if (lc.legal_documents) {
            this.documents = {
              deed_of_incorporation_path: lc.legal_documents.deed_of_incorporation_path,
              siup_path: lc.legal_documents.siup_path,
              npwp_path: lc.legal_documents.npwp_path,
              skdp_path: lc.legal_documents.skdp_path,
              nib_path: lc.legal_documents.nib_path,
            }
          }
          if (lc.certificates) {
            if (lc.certificates.alfa_ifa) this.certifications.push('ALFA/IFA')
            if (lc.certificates.iata) this.certifications.push('IATA')
            if (lc.certificates.fiata) this.certifications.push('FIATA')
            if (lc.certificates.dangerous_good) this.certifications.push('Barang Berbahaya')
            if (lc.certificates.other_detail) this.certifications.push(lc.certificates.other_detail)
          }
          this.getCities()
        })
    },
    getIndustries() {
      this.$axios.get('/v1/industry', {
        params: {
          page: 1,
          per_page: 100,
          orderby: 'name',
          sort: 'asc',
          status: 'aktif'
        }
      })
        .then(response => {
          this.industryList = response.data.data.rows.map(item => {
            return { value: item.id.toString(), text: item.name }
          })
          this.industryList.unshift({ value: null, text: 'Please select an industry' })
        })
    },
    getProvinces() {
      this.$axios.get('/v1/province')
        .then(response => {
          this.provinceList = response.data.data.map(item => {
            return { value: item.id.toString(), text: item.name }
          })
          this.provinceList.unshift({ value: null, text: 'Please select a province' })
        })
    },
    getCities() {
      this.$axios.get('/v1/cities', {
        params: {
          province_id: this.form.province_id
        }
      })
        .then(response => {
          this.cityList = response.data.data.map(item => {
            return { value: item.id.toString(), text: item.name }
          })
          this.cityList.unshift({ value: null, text: 'Please select a city' })
        })
    },
    uploadDocument(event) {
      if(event.target.files[0] !== undefined){
        let extension = event.target.files[0].name.split(".").pop()
        let allowedExtention = ['jpg','jpeg','png','pdf']
        if(allowedExtention.includes(extension.toLowerCase())){
          let param = new FormData();
          param.append('file', event.target.files[0])
          param.append('status', 'active') 
          param.append('title', event.target.name)
          param.append('description', 'document')

          this.$axios.post('/v1/admin/media', param)
            .then(response => {
              if (event.target.name === 'upload_akta_pendirian_usaha') {
                this.documents.deed_of_incorporation_path = response.data.data.file
              } else if (event.target.name === 'upload_npwp') {
                this.documents.npwp_path = response.data.data.file
              } else if (event.target.name === 'upload_siup') {
                this.documents.siup_path = response.data.data.file
              } else if (event.target.name === 'upload_skdp') {
                this.documents.skdp_path = response.data.data.file
              } else {
                this.documents.nib_path = response.data.data.file
              }
              this.submitLegalDocument()
            })

        }else{
          this.isUpdateProfileError = true
          this.errorMessage = "image extentions not allowed"
        }
      }
    },
    previewDoc(doc) {
      const extention = doc.split(".").pop()
      this.document = {
        type: extention,
        src: doc
      }
      this.$refs.modalDocument.show()
    }
  }
};
</script>

<template>
  <Layout>
    <!-- start page title -->
    <div class="row align-items-center">
      <div class="col-sm-6">
        <div class="page-title-box">
          <h4 class="font-size-18">Ubah Profil</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <b-form @submit.prevent="submitUpdateProfile">
              <b-alert
                v-model="isUpdateProfileSuccess"
                class="mt-3"
                variant="success"
                dismissible
              >{{ successMessage }}</b-alert>

              <b-alert
                v-model="isUpdateProfileError"
                class="mt-3"
                variant="danger"
                dismissible
              >{{errorMessage}}</b-alert>

              <div class="form-group row">
                <div class="col-sm-4">
                  <b-form-group id="name-group" label="Nama" label-for="name">
                    <b-form-input
                      id="name"
                      name="name"
                      v-model.trim="form.name"
                      type="text"
                      :class="{ 'is-invalid': $v.form.name.$error }"
                    ></b-form-input>
                    <div v-if="$v.form.name.$error" class="invalid-feedback">
                      <span v-if="!$v.form.name.required">{{ $t('form.validation.required', { field: $t('form.field.name') }) }}</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-4">
                  <b-form-group id="email-group" label="Email" label-for="email">
                    <b-form-input
                      id="email"
                      name="email"
                      v-model.trim="form.email"
                      type="text"
                      :class="{ 'is-invalid': $v.form.email.$error }"
                    ></b-form-input>
                    <div v-if="$v.form.email.$error" class="invalid-feedback">
                      <span v-if="!$v.form.email.required">{{ $t('form.validation.required', { field: 'Email' }) }}</span>
                      <span v-if="!$v.form.email.email">{{ $t('form.validation.email', { field: 'Email' }) }}</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-4">
                  <b-form-group id="phone-group" label="Telepone" label-for="phone">
                    <b-form-input
                      id="phone"
                      name="phone"
                      v-model.trim="form.phone"
                      type="text"
                      :class="{ 'is-invalid': $v.form.phone.$error }"
                    ></b-form-input>
                    <div v-if="$v.form.phone.$error" class="invalid-feedback">
                      <span v-if="!$v.form.phone.required">{{ $t('form.validation.required', { field: $t('form.field.phone') }) }}</span>
                      <span v-if="!$v.form.phone.minLength">{{ $t('form.validation.min_length', { field: $t('form.field.phone'), length: 8 }) }}</span>
                      <span v-if="!$v.form.phone.maxLength">{{ $t('form.validation.max_length', { field: $t('form.field.phone'), length: 15 }) }}</span>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <b-form-group id="address-group" label="Alamat" label-for="address">
                <b-textarea
                  id="address"
                  name="address"
                  v-model.trim="form.address"
                  :class="{ 'is-invalid': $v.form.address.$error }"
                  rows="5"
                ></b-textarea>
                <div v-if="$v.form.address.$error" class="invalid-feedback">
                  <span v-if="!$v.form.address.required">{{ $t('form.validation.required', { field: $t('form.field.address') }) }}</span>
                </div>
              </b-form-group>

              <b-form-group id="industry-group" label="Industry" label-for="industry">
                <b-form-select
                  id="industry"
                  name="industry"
                  v-model.trim="form.industry_id"
                  :options="industryList"
                  :class="{ 'is-invalid': $v.form.industry_id.$error }"
                ></b-form-select>
                <div v-if="$v.form.industry_id.$error" class="invalid-feedback">
                  <span v-if="!$v.form.industry_id.required">{{ $t('form.validation.required', { field: $t('form.field.industry') }) }}</span>
                </div>
              </b-form-group>

              <div class="form-group row">
                <div class="col-lg-4">
                  <b-form-group id="province-group" label="Provinsi" label-for="province">
                    <b-form-select
                      id="province"
                      name="province"
                      v-model.trim="form.province_id"
                      :options="provinceList"
                      :class="{ 'is-invalid': $v.form.province_id.$error }"
                      @change="getCities"
                    ></b-form-select>
                    <div v-if="$v.form.province_id.$error" class="invalid-feedback">
                      <span v-if="!$v.form.province_id.required">{{ $t('form.validation.required', { field: $t('form.field.province') }) }}</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-lg-4">
                  <b-form-group id="city-group" label="Kota" label-for="city">
                    <b-form-select
                      id="city"
                      name="city"
                      v-model.trim="form.city_id"
                      :options="cityList"
                      :class="{ 'is-invalid': $v.form.city_id.$error }"
                    ></b-form-select>
                    <div v-if="$v.form.city_id.$error" class="invalid-feedback">
                      <span v-if="!$v.form.city_id.required">{{ $t('form.validation.required', { field: $t('form.field.city') }) }}</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-lg-4">
                  <b-form-group id="zip_code-group" label="Kode Pos" label-for="zip_code">
                    <b-form-input
                      id="zip_code"
                      name="zip_code"
                      v-model.trim="form.zip_code"
                      :class="{ 'is-invalid': $v.form.zip_code.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.zip_code.$error" class="invalid-feedback">
                      <span v-if="!$v.form.zip_code.required">{{ $t('form.validation.required', { field: $t('form.field.postal_code') }) }}</span>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-6">
                  <b-form-group id="contact-group" label="Kontak Personal" label-for="contact">
                    <b-form-input
                      id="contact"
                      name="contact"
                      v-model.trim="form.contact_person"
                      :class="{ 'is-invalid': $v.form.contact_person.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.contact_person.$error" class="invalid-feedback">
                      <span v-if="!$v.form.contact_person.required">{{ $t('form.validation.required', { field: $t('form.field.personal_contact') }) }}</span>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-6">
                  <b-form-group id="yearly_income-group" label="Pendapatan / Tahun" label-for="yearly_income">
                    <b-form-input
                      id="yearly_income"
                      name="yearly_income"
                      v-model.lazy="form.yearly_income"
                      v-money="{ prefix: '', thousands: '.', precision: '0'}"
                      :class="{ 'is-invalid': $v.form.yearly_income.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.yearly_income.$error" class="invalid-feedback">
                      <span v-if="!$v.form.yearly_income.required">{{ $t('form.validation.required', { field: 'Pendapatan / Tahun' }) }}</span>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <b-form-group id="cerfitication-group" v-slot="{ ariaDescribedby }">
                <div class="row">
                  <div class="col-sm-6">
                    <label>Sertifikat</label>
                    <b-form-checkbox-group
                      id="checkbox-group-form"
                      v-model="certifications"
                      :options="certificationList"
                      :aria-describedby="ariaDescribedby"
                      name="cerfitication"
                    ></b-form-checkbox-group>
                  </div>
                  <div class="col-sm-6 pt-4">
                    <b-form-group id="other_certification-group" label="Sertifikat Lainnya" label-for="other_certification">
                      <b-form-input
                        id="other_certification"
                        name="other_certification"
                        v-model.trim="form.other_certification"
                        type="text"
                        :class="{ 'is-invalid': $v.form.other_certification.$invalid }"
                      ></b-form-input>
                      <div v-if="$v.form.other_certification.$invalid" class="invalid-feedback">
                        <span v-if="!$v.form.other_certification.required">{{ $t('form.validation.required', { field: 'Sertifikat Lainnya' }) }}</span>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </b-form-group>

              <div class="row mb-4">
                <div class="col-sm-2">
                  <div class="border-radius text-center py-2">
                    <p class="font-weight-medium mb-1">Akta Pendirian Usaha</p>
                    <p class="font-weight-medium mb-1" v-if="documents.deed_of_incorporation_path">
                      <a class="cursor-pointer my-3 text-danger curosr-pointer" @click="previewDoc(documents.deed_of_incorporation_path)">
                        Lihat File
                      </a>
                    </p>
                    <b-link class="cursor-pointer text-danger" @click="$refs.uploadAktaPendirianUsaha.click()">Upload</b-link>
                  </div>
                  <input type="file" name="upload_akta_pendirian_usaha" ref="uploadAktaPendirianUsaha" @change="uploadDocument"  />
                </div>
                <div class="col-sm-2">
                  <div class="border-radius text-center py-2">
                    <p class="font-weight-medium mb-1">NPWP</p>
                    <p class="font-weight-medium mb-1" v-if="documents.npwp_path">
                      <a class="cursor-pointer my-3 text-danger curosr-pointer" @click="previewDoc(documents.npwp_path)">
                        Lihat File
                      </a>
                    </p>
                    <b-link class="cursor-pointer text-danger" @click="$refs.updateNpwp.click()">Upload</b-link>
                  </div>
                  <input type="file" name="upload_npwp" ref="updateNpwp" @change="uploadDocument" />
                </div>
                <div class="col-sm-2">
                  <div class="border-radius text-center py-2">
                    <p class="font-weight-medium mb-1">SIUP / SIUJPT</p>
                    <p class="font-weight-medium mb-1" v-if="documents.siup_path">
                      <a class="cursor-pointer my-3 text-danger curosr-pointer" @click="previewDoc(documents.siup_path)">
                        Lihat File
                      </a>
                    </p>
                    <b-link class="cursor-pointer text-danger" @click="$refs.updateSiup.click()">Upload</b-link>
                  </div>
                  <input type="file" name="upload_siup" ref="updateSiup" @change="uploadDocument" />
                </div>
                <div class="col-sm-2">
                  <div class="border-radius text-center py-2">
                    <p class="font-weight-medium mb-1">SKDP</p>
                    <p class="font-weight-medium mb-1" v-if="documents.skdp_path">
                      <a class="cursor-pointer my-3 text-danger curosr-pointer" @click="previewDoc(documents.skdp_path)">
                        Lihat File
                      </a>
                    </p>
                    <b-link class="cursor-pointer text-danger" @click="$refs.updateSkdp.click()">Upload</b-link>
                  </div>
                  <input type="file" name="upload_skdp" ref="updateSkdp" @change="uploadDocument" />
                </div>
                <div class="col-sm-2">
                  <div class="border-radius text-center py-2">
                    <p class="font-weight-medium mb-1">NIB</p>
                    <p class="font-weight-medium mb-1" v-if="documents.nib_path">
                      <a class="cursor-pointer my-3 text-danger curosr-pointer" @click="previewDoc(documents.nib_path)">
                        Lihat File
                      </a>
                    </p>
                    <b-link class="cursor-pointer text-danger" @click="$refs.updateNib.click()">Upload</b-link>
                  </div>
                  <input type="file" name="upload_nib" ref="updateNib" @change="uploadDocument" />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-sm-2">
                  <b-button to="/profile" type="button" class="w-100 btn-light">Kembali</b-button>
                </div>
                <div class="col-sm-2">
                  <b-button type="submit" variant="danger" class="w-100">Simpan</b-button>
                </div>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <!-- modal preview document -->
    <b-modal title="Preview" ref="modalDocument" id="modal-document" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row">
        <div class="col-lg-12 text-center">
          <pdf v-if="document.type === 'pdf'" :src="document.src"></pdf>
          <b-img v-else fluid :src="document.src"></b-img>
        </div>
      </div>
    </b-modal>
    <!-- / modal-->
  </Layout>
</template>

<style scoped>
.icon-panah {
  position: absolute;
  top: 35%;
  left: 0%;
}
.content-slider {
  position: relative;
}
.nav-kiri {
  cursor: pointer;
  position: absolute;
  top: 45%;
  left: 5%;
}
.nav-kanan {
  cursor: pointer;
  position: absolute;
  top: 45%;
  right: 5%;
}

.total-job {
  position: absolute;
  top: 25%;
  right: 50%;
}

input[type=file] {
  visibility: hidden;
}
</style>